import Footer from 'csdd_components/Footer';
import HomeNavBar from 'csdd_components/HomeNavBar';
import NewsContent from 'csdd_components/NewsContent';
import NewsHeader from 'csdd_components/NewsHeader';
import Newsletter from 'csdd_components/Newsletter';
import TopNavBar from 'csdd_components/TopNavBar';

const News = () => {
  return (
    <>
      <TopNavBar />
      <HomeNavBar />
      <NewsHeader />
      <NewsContent />
      <Newsletter />
      <Footer />
    </>
  );
};
export default News;
